export type NewsBlock =
  | { type: "p"; text: string }
  | { type: "h"; text: string }
  | { type: "quote"; text: string }
  | { type: "img"; src: string; caption: string };

export interface NewsItem {
  id: string;
  title: string;
  category: string;
  publishedAt: string;
  source: string;
  summary: string;
  cover: string;
  content: NewsBlock[];
}

export const newsCategories = ["全部", "影评", "行业资讯", "电影节"];

export const newsList: NewsItem[] = [
  {
    id: "deep-blue-line-review",
    title: "《深海蓝线》凭什么成为今年最值得二刷的华语科幻？",
    category: "影评",
    publishedAt: "2026-10-12",
    source: "CC视频影评组",
    summary:
      "没有炫技的大场面，却让人散场后仍能听见那片海的声音。《深海蓝线》用一千一百米的压强，讲了一个关于“被看见”的故事。",
    cover: "https://readdy.ai/api/search-image?query=cinematic%20editorial%20image%20of%20a%20deep%20ocean%20submersible%20window%20glowing%20warm%20orange%20against%20deep%20navy%20water%2C%20moody%20scientific%20atmosphere%2C%20high%20detail%20film%20journal%20photography%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=cc-news-01&orientation=landscape",
    content: [
      {
        type: "p",
        text: "《深海蓝线》上映前几乎没有任何宣传材料，只放出了一段四十秒的声呐录音。等到正式上映，这段录音成了整部电影最被反复讨论的部分——它既不是音效，也不是配乐，而是导演程砚舟坚持要用的真实水文数据。",
      },
      { type: "h", text: "一、把恐惧拍成沉默" },
      {
        type: "p",
        text: "与多数深海题材不同，这部片子里几乎没有怪物。真正带来压迫感的是舱壁的轻微震颤、氧气表的指针，以及队员们彼此说话时越来越短的句子。程砚舟把镜头长时间地停在人物脸上，让观众和他们一起听那三十秒的沉默。",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=cinematic%20still%20of%20a%20submarine%20interior%20with%20warm%20orange%20instrument%20lights%20and%20deep%20navy%20shadows%2C%20tight%20crew%20quarters%2C%20tense%20sci-fi%20atmosphere%2C%20film%20grain%2C%20wide%20composition&width=1000&height=560&seq=cc-news-01-inline&orientation=landscape",
        caption: "影片中大量使用实景搭建的舱内拍摄，橙色的仪表光成为唯一的暖色来源。",
      },
      { type: "h", text: "二、一次关于“被看见”的隐喻" },
      {
        type: "p",
        text: "片中反复出现的那段低频信号，在第三幕被解读为一种“回声”——某样东西在证明自己存在。陆沉最后选择关掉灯，让舱内陷入完全的黑暗，那一刻全场观众几乎同时屏住了呼吸。这不是经典的英雄式选择，却更接近人在极端处境下的真实反应。",
      },
      {
        type: "quote",
        text: "“我们不是去找答案的，我们是去确认有人在那里。”——片中台词",
      },
      {
        type: "p",
        text: "从技术层面看，《深海蓝线》的调色偏向冷峻的深蓝，橙色的出现极其克制，几乎只用于人眼、灯光和最后的那个信号点。这种色彩策略让全片在视觉上非常统一，也把橙色的每一次出现都变成了情绪事件。",
      },
      {
        type: "p",
        text: "如果你只看一遍，可能会觉得节奏偏慢；但二刷时会发现，前四十分钟里每一句闲聊都在为结局埋线。这大概就是它被称为“年度最值得二刷”的原因。",
      },
    ],
  },
  {
    id: "shadow-division-finale",
    title: "《暗影分局》收官周热度破纪录，结尾这段独白被剪进预告",
    category: "行业资讯",
    publishedAt: "2026-10-09",
    source: "CC视频剧集观察",
    summary:
      "上线六周，《暗影分局》以超过二十九亿的有效播放量收官。最后一集沈砚在天台上的独白，成为本周社交平台转发最多的一段台词。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20an%20empty%20rooftop%20at%20night%20with%20a%20single%20warm%20orange%20light%20and%20deep%20navy%20city%20skyline%20in%20the%20background%2C%20crime%20series%20atmosphere%2C%20moody%20cinematic%20editorial%20style%2C%20high%20detail&width=800&height=500&seq=cc-news-02&orientation=landscape",
    content: [
      {
        type: "p",
        text: "收官当晚，《暗影分局》在平台站内热度峰值达到 9842，创下今年以来剧集类内容的新高。最后一集上线四小时内，相关话题在社交平台累计阅读量突破十二亿。",
      },
      { type: "h", text: "把“结案”拍成“放手”" },
      {
        type: "p",
        text: "编剧组在最后的处理上做了一个冒险的决定：没有让主角亲手抓住真凶，而是让他把那份卷宗放回了档案柜。这个处理在播出后引发了大量讨论，有人认为不够爽，也有人认为这是全剧唯一合乎逻辑的结束方式。",
      },
      {
        type: "quote",
        text: "“有些案子结不了，但人可以从里面走出来。”",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=cinematic%20still%20of%20a%20dimly%20lit%20police%20archive%20room%20with%20wooden%20cabinets%20and%20a%20single%20desk%20lamp%2C%20deep%20navy%20shadows%20with%20warm%20orange%20light%2C%20procedural%20drama%20mood%2C%20wide%20composition&width=1000&height=560&seq=cc-news-02-inline&orientation=landscape",
        caption: "第 36 集中反复出现的档案室场景，是全剧拍摄周期最长的一个景。",
      },
      { type: "h", text: "平台剧集的另一种可能" },
      {
        type: "p",
        text: "从制作层面看，《暗影分局》放弃了常见的强情节推进，转而把大量篇幅留给审讯室里两个人的对话。这种“低动作、高信息”的做法在今年的市场上并不多见，也让人重新讨论起长剧集的节奏边界。",
      },
      {
        type: "p",
        text: "据平台透露，该剧的续作已在剧本阶段，但主创团队明确表示不会为了延续热度而改变原有的叙事节奏。",
      },
    ],
  },
  {
    id: "autumn-film-festival",
    title: "2026 秋季电影节片单公布：四部华语片入围主竞赛",
    category: "电影节",
    publishedAt: "2026-10-06",
    source: "CC视频资讯中心",
    summary:
      "本届秋季电影节主竞赛单元共入围二十一部影片，其中四部为华语作品，包括两部首次亮相的长片处女作。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20image%20of%20an%20empty%20cinema%20auditorium%20with%20rows%20of%20seats%20and%20a%20warm%20orange%20screen%20glow%2C%20deep%20navy%20shadows%2C%20film%20festival%20atmosphere%2C%20elegant%20cinematic%20photography%2C%20wide%20symmetrical%20composition&width=800&height=500&seq=cc-news-03&orientation=landscape",
    content: [
      {
        type: "p",
        text: "电影节组委会于本周公布了完整片单。主竞赛单元二十一部影片中，华语作品占到四部，是近五年来的最高比例。其中《高原上的春天》与《给海的信》都是导演的第二部作品。",
      },
      { type: "h", text: "题材走向：从奇观回到日常" },
      {
        type: "p",
        text: "从片单结构看，今年入围作品的共同特征是“把镜头收回生活”。家庭关系、代际沟通、小城变迁成为高频主题，科幻与类型片比例明显下降。",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20a%20film%20festival%20red%20carpet%20entrance%20at%20dusk%20with%20warm%20orange%20lights%20and%20deep%20navy%20evening%20sky%2C%20elegant%20restrained%20composition%2C%20cinematic%20editorial%20style&width=1000&height=560&seq=cc-news-03-inline&orientation=landscape",
        caption: "本届电影节将于下周开幕，展映单元将新增午夜场与修复经典单元。",
      },
      { type: "h", text: "新增修复单元" },
      {
        type: "p",
        text: "除主竞赛外，本届新增“修复经典”单元，将放映十二部经过 4K 修复的老片。组委会表示，这一单元是为了让年轻观众有机会在大银幕上理解电影的“时间感”。",
      },
      {
        type: "p",
        text: "完整片单与排片表将于开幕前三天在官方渠道公布，CC视频也将在展映期间推出系列专题报道。",
      },
    ],
  },
  {
    id: "midnight-diner-healing",
    title: "为什么我们总在深夜看《深夜食堂·夜航》",
    category: "影评",
    publishedAt: "2026-10-02",
    source: "特约撰稿 / 陆抒",
    summary:
      "一集二十分钟，一碗汤，一个陌生人的故事。这部没有悬念的剧集，成了很多人睡前最后打开的东西。",
    cover: "https://readdy.ai/api/search-image?query=warm%20editorial%20image%20of%20a%20steaming%20bowl%20of%20soup%20on%20a%20wooden%20counter%20at%20night%20lit%20by%20a%20single%20orange%20lantern%2C%20deep%20navy%20background%2C%20cozy%20intimate%20food%20photography%2C%20shallow%20depth%20of%20field&width=800&height=500&seq=cc-news-04&orientation=landscape",
    content: [
      {
        type: "p",
        text: "《深夜食堂·夜航》几乎违背了当下剧集的所有规律：没有主线悬念，没有强钩子，每集二十分钟结束，甚至没有结尾配乐。但上线三个月，它的完播率始终保持在同类型的第一梯队。",
      },
      { type: "h", text: "一碗汤的叙事效率" },
      {
        type: "p",
        text: "每一集的结构极度相似：客人进门、点单、说话、上菜、离开。真正变化的只有那个说话的人。导演森田葵把镜头几乎全部固定在一个位置上，反而让观众更注意听。",
      },
      {
        type: "quote",
        text: "“热的东西会把话带出来。”——第一集台词",
      },
      {
        type: "p",
        text: "从观众行为数据看，这部剧的播放高峰集中在 23 点至次日 1 点之间，且中途暂停率显著低于同类型内容。它更像是一种陪伴，而不是需要被追的剧。",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=cinematic%20still%20of%20a%20small%20diner%20kitchen%20at%20night%20with%20a%20chef%20silhouette%20cooking%2C%20warm%20orange%20lamp%20light%20and%20deep%20navy%20shadows%2C%20cozy%20japanese%20drama%20atmosphere%2C%20soft%20focus%2C%20wide%20composition&width=1000&height=560&seq=cc-news-04-inline&orientation=landscape",
        caption: "厨房几乎是全剧唯一固定机位，观众的注意力被自然地交给了声音。",
      },
      { type: "h", text: "被允许的沉默" },
      {
        type: "p",
        text: "有意思的是，剧中最打动人的段落往往没有台词。客人低头喝汤的那几秒，老板擦碗的动作，门帘被风吹起的声音——这些“不推进剧情”的镜头，反而构成了它的核心竞争力。",
      },
    ],
  },
  {
    id: "streaming-trend-2026",
    title: "长剧集正在变短：2026 年剧集市场的三个明显信号",
    category: "行业资讯",
    publishedAt: "2026-09-28",
    source: "CC视频资讯中心",
    summary:
      "从 40 集到 24 集，从季播到窗口期播出，今年剧集市场的变化并不是“产能减少”这么简单。",
    cover: "https://readdy.ai/api/search-image?query=abstract%20editorial%20image%20of%20film%20strip%20and%20data%20charts%20on%20a%20dark%20navy%20surface%20with%20warm%20orange%20highlights%2C%20modern%20media%20industry%20concept%2C%20minimal%20clean%20studio%20lighting%2C%20high%20detail&width=800&height=500&seq=cc-news-05&orientation=landscape",
    content: [
      {
        type: "p",
        text: "根据平台公开数据，2026 年上线的剧集中，单季集数在 24 集以内的作品占比首次超过一半，平均单集时长也下降了约四分钟。这些数字背后，是内容生产与观看习惯的双重变化。",
      },
      { type: "h", text: "信号一：迷你剧成为主流形态" },
      {
        type: "p",
        text: "十二到十六集的短季结构，正在从“实验”变成“标准”。制作周期更可控，也让创作者有机会把每一集都做成完整的小单元。",
      },
      { type: "h", text: "信号二：单元剧重新被接受" },
      {
        type: "p",
        text: "《深夜食堂·夜航》这类单元式作品的成功，说明观众并不排斥弱主线的结构。在碎片化观看场景里，“随时能进入”反而是一种优势。",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=modern%20editorial%20scene%20of%20a%20editing%20suite%20with%20multiple%20screens%20showing%20video%20timelines%2C%20dark%20navy%20room%20with%20warm%20orange%20monitor%20glow%2C%20film%20production%20atmosphere%2C%20wide%20composition&width=1000&height=560&seq=cc-news-05-inline&orientation=landscape",
        caption: "后期制作环节的数字化，让短季剧集的产能显著提升。",
      },
      { type: "h", text: "信号三：窗口期被压缩" },
      {
        type: "p",
        text: "院线片上线流媒体的窗口期，从过去的三到六个月缩短到平均四十天。对平台而言，这意味着内容更新的节奏必须更快；对观众而言，则意味着“错过就很久看不到”的焦虑正在减少。",
      },
      {
        type: "p",
        text: "对创作者来说，更短的形式并不等于更低的门槛。恰恰相反，观众对信息密度的要求，正在以肉眼可见的速度上升。",
      },
    ],
  },
  {
    id: "spring-on-the-plateau-interview",
    title: "专访《高原上的春天》导演：我们拍的不是苦难",
    category: "影评",
    publishedAt: "2026-09-21",
    source: "特约撰稿 / 罗沉",
    summary:
      "“如果把镜头对着一片草地拍三分钟，观众会觉得难看吗？”桑吉卓玛的回答是：先让他听见风。",
    cover: "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20a%20vast%20grassland%20plateau%20with%20silver%20grey%20overcast%20sky%20and%20a%20thin%20band%20of%20warm%20orange%20sunlight%20at%20the%20horizon%2C%20wind%20sweeping%20grass%2C%20minimal%20poetic%20landscape%20photography&width=800&height=500&seq=cc-news-06&orientation=landscape",
    content: [
      {
        type: "p",
        text: "《高原上的春天》是桑吉卓玛的第二部长片。全片有近三分之一的时间没有任何台词，只有风、羊群和人的呼吸。"
      },
      { type: "h", text: "先把环境拍对，人自然会出现" },
      {
        type: "p",
        text: "“很多关于高原的片子，都在拍艰苦。”她说，“但生活在那里的人，不会每天都觉得艰苦。他们更多是在处理一些具体的小事，比如水要打几趟，羊什么时候回来。”",
      },
      {
        type: "quote",
        text: "“我不想让观众同情他们，我想让观众认出自己。”",
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=documentary%20style%20photo%20of%20a%20mother%20and%20child%20sitting%20inside%20a%20tibetan%20tent%2C%20warm%20orange%20firelight%20against%20silver%20grey%20cold%20exterior%20light%2C%20quiet%20intimate%20moment%2C%20natural%20available%20light%20photography&width=1000&height=560&seq=cc-news-06-inline&orientation=landscape",
        caption: "片中最重要的一场戏，只用了帐篷里的一盏酥油灯照明。",
      },
      { type: "h", text: "关于结尾的争议" },
      {
        type: "p",
        text: "影片结尾并没有给出和解，母亲只是坐上了回城的班车。有观众觉得克制，也有人觉得遗憾。对此导演的回答很直接：“如果结尾很容易被接受，那这个夏天就白过了。”",
      },
    ],
  },
  {
    id: "neon-precinct-craft",
    title: "从霓虹到雨声：《霓虹特区》的影像方法论",
    category: "影评",
    publishedAt: "2026-09-15",
    source: "CC视频影评组",
    summary:
      "十八集，几乎每一集都在下雨。这不只是氛围，而是一套被严格执行的视觉规则。",
    cover: "https://readdy.ai/api/search-image?query=neon%20soaked%20night%20alley%20reflection%20editorial%20photography%20in%20silver%20grey%20and%20warm%20orange%2C%20rainy%20asphalt%20with%20color%20reflections%2C%20cinematic%20moody%20atmosphere%2C%20high%20detail&width=800&height=500&seq=cc-news-07&orientation=landscape",
    content: [
      {
        type: "p",
        text: "《霓虹特区》的美术指导在接受采访时提到，剧组制定了一份“色彩纪律”：橙色只能出现在人造光源上，自然光必须保持冷灰。这条规则让全剧在任何场景下都能一眼辨认。"
      },
      {
        type: "img",
        src: "https://readdy.ai/api/search-image?query=cinematic%20still%20of%20wet%20city%20street%20at%20night%20with%20layered%20orange%20and%20silver%20reflectivity%2C%20blurred%20figures%20under%20umbrellas%2C%20rain%20in%20air%2C%20moody%20noir%20series%20atmosphere&width=1000&height=560&seq=cc-news-07-inline&orientation=landscape",
        caption: "雨在整个拍摄周期中由人工降雨系统维持，以保证每一集的反射效果一致。",
      },
      { type: "h", text: "用声音代替剪辑" },
      {
        type: "p",
        text: "许多转场并不依靠镜头剪辑，而是依靠雨声的连续。一场戏从街角走到室内，雨声始终没有断，观众的空间感因此被保住了。"
      },
      {
        type: "p",
        text: "这种处理在高密度的悬疑剧中并不常见，却恰好解释了为什么《霓虹特区》的节奏虽然慢，但观众并不容易走神。"
      },
    ],
  },
];